import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {SlideTree} from './SlideTree';
import {DesignChapter} from '@learningblocks/storybook-components';
import {StepViewComplete} from './StepViewComplete';
import {TechniqueViewComplete} from './TechniqueViewComplete';
import {Hint} from './Hint';
import {Utilities} from '@learningblocks/exp-constants';
const {resetScroll} = Utilities;

import './style.scss';

export function DesignWeb(props) {
  const className = props.collapsed ? 'c-designWEB' : 'designWEB';

  const isDesignChapterRef = React.useRef(props.isDesignChapter);

  useEffect(() => {
    if (!isDesignChapterRef.current && props.isDesignChapter) {
      resetScroll('designWEB'), [props.isDesignChapter];
    }
    isDesignChapterRef.current = props.isDesignChapter;
  });

  const tabIndex = props.isDesignChapter || props.collapsed ? 0 : -1;

  const appylHint = () => {
    if (props.viewType === 'STEPS') props.viewThreeHint();
    else props.viewFourHint();
  };
  return (
    <DesignChapter.Wrapper 
      tabIndex={tabIndex} 
      className={className}
      ariaHidden={!props.collapsed && !props.isDesignChapter}
    >
      <DesignChapter.ViewTabPane
        tabIndex={tabIndex}
        className='d-tabPane'
        title={props.title}
        description={props.description}
        current={props.viewType}
        onTabSelect={props.onSetTab}
      />
      <DesignChapter.ViewWrap className='d-view'>
        <SlideTree tabIndex={tabIndex} slideTree={props.slideTree} />
      </DesignChapter.ViewWrap>
      {props.hintVisibility && (
        <Hint
          tabIndex={tabIndex}
          useHint={appylHint}
          className={`${className}_hint`}
        />
      )}
      {props.viewType === 'STEPS' ? (
        <StepViewComplete />
      ) : (
        <TechniqueViewComplete nextMenuValue={props.nextMenuValue}/>
      )}
    </DesignChapter.Wrapper>
  );
}

DesignWeb.propTypes = {
  /**
   * Boolean set when Notebook Drawer is collapsed
   */
  collapsed: PropTypes.bool,
  /**
   * description for the particular Slide
   */
  description: PropTypes.arrayOf(PropTypes.string),
  /**
   * title for the particular slide
   */
  title: PropTypes.string,
  /**
   * type of Slide View
   */
  viewType: PropTypes.oneOf(['STEPS', 'TECHNIQUES']).isRequired,
  /**
   * Function to call when ViewTab is selected
   */
  onSetTab: PropTypes.func.isRequired,
  /**
   * Data corrospinding to the particular design slide
   */

  slideTree: PropTypes.arrayOf(PropTypes.object),
  /**
   * bool value to display hint
   */
  hintVisibility: PropTypes.bool,
  /**
   * function for applying hint in viewFour
   */
  viewFourHint: PropTypes.func,
  /**
   * function for applying hint in viewThree
   */
  viewThreeHint: PropTypes.func,
  /**
   * bool value to check if currentChapter selected is DesignChapter (for resetting scrool)
   */
  isDesignChapter: PropTypes.bool,
};

DesignWeb.defaultProps = {
  title: '',
  description: [],
};
